import React, { useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import "react-toastify/dist/ReactToastify.css";
import { getAllWebContent } from '../../redux/reducers/user';
import Blog from '../PersonalFinance/components/Blog';
import BlogBottom from '../PersonalFinance/components/BlogBottom';
import CallToAction from '../PersonalFinance/components/CallToAction';
import FinancialCoachingProcess from '../PersonalFinance/components/FinancialCoachingProcess';
import Footer from '../PersonalFinance/components/Footer';
import Header from '../PersonalFinance/components/Header';
import './FinancePlanning.css';

function FinancePlanning() {
  const dispatch = useDispatch();

  const { translationState, allWebContent } = useSelector((state) => state.user);
  const { userLanguage } = useSelector((state) => state.auth);

  // Use translation if available, otherwise fall back to default content
  const financeplanning = allWebContent?.[0]?.financeplanning || {};
  const financeplanningTranslation = translationState?.[0]?.translations?.financeplanning?.[userLanguage] || {};
  const content = Object.keys(financeplanningTranslation).length > 0 ? financeplanningTranslation : financeplanning;



  useEffect(() => {
    dispatch(getAllWebContent());
  }, [dispatch]);

  return (
    <>
      <Header content={content} />
      <main role="main" aria-label="Finance planning information">
        <Blog content={content} />
        <FinancialCoachingProcess content={content} />
        <BlogBottom content={content} />
        {/* <CallToAction content={content} /> */}
      </main>
      <Footer content={content} />
    </>
  );
}

export default FinancePlanning;
